let tmp = ''

if(window.location.port === '3000'){
  tmp = "http://localhost:1337"
}

export const host = tmp
